(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-ccc-section]';

  function getRootUrl(section) {
    var root = section.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function getCardStep(track) {
    if (!track) return 0;

    var card = track.querySelector('[data-ccc-card]');
    if (!card) return track.clientWidth;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateCarousel(section) {
    var track = section.querySelector('[data-ccc-track]');
    var previous = section.querySelector('[data-ccc-prev]');
    var next = section.querySelector('[data-ccc-next]');
    var progress = section.querySelector('[data-ccc-progress]');
    var controls = section.querySelector('[data-ccc-controls]');

    if (!track) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var currentScroll = Math.max(0, Math.min(maxScroll, track.scrollLeft));
    var hasOverflow = maxScroll > 3;

    if (previous) previous.disabled = !hasOverflow || currentScroll <= 3;
    if (next) next.disabled = !hasOverflow || currentScroll >= maxScroll - 3;

    if (progress) {
      var visibleRatio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      var travelRatio = maxScroll > 0 ? currentScroll / maxScroll : 0;
      var width = Math.max(12, Math.min(100, visibleRatio * 100));
      var left = (100 - width) * travelRatio;

      progress.style.width = width + '%';
      progress.style.transform = 'translateX(' + (left / Math.max(width, 0.001) * 100) + '%)';
    }

    if (controls) controls.classList.toggle('is-static', !hasOverflow);
  }

  function scrollTrack(section, direction) {
    var track = section.querySelector('[data-ccc-track]');
    if (!track) return;

    var amount = getCardStep(track) * direction;
    track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  function setButtonState(button, text, stateClass, disabled) {
    if (!button) return;

    var textNode = button.querySelector('[data-ccc-button-text]');
    if (textNode) textNode.textContent = text;

    button.classList.remove('is-loading', 'is-added', 'is-error');
    if (stateClass) button.classList.add(stateClass);
    button.disabled = Boolean(disabled);
  }

  function updateVariantCard(card, select) {
    if (!card || !select) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = card.querySelector('[data-ccc-price]');
    var comparePrice = card.querySelector('[data-ccc-compare-price]');
    var saleBadge = card.querySelector('[data-ccc-sale-badge]');
    var image = card.querySelector('.cleeny-collection-carousel__image');
    var button = card.querySelector('[data-ccc-add-button]');
    var available = option.dataset.available === 'true' && !option.disabled;
    var onSale = option.dataset.onSale === 'true';

    if (price) price.textContent = option.dataset.price || '';

    if (comparePrice) {
      comparePrice.textContent = onSale ? (option.dataset.comparePrice || '') : '';
      comparePrice.classList.toggle('is-hidden', !onSale);
    }

    if (saleBadge) saleBadge.classList.toggle('is-hidden', !onSale);

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.srcset = '';
      image.alt = option.dataset.imageAlt || image.alt || '';
    }

    if (button) {
      var defaultText = button.dataset.defaultText || 'Add to Cart';
      var soldOutText = button.dataset.soldOutText || 'Sold Out';
      setButtonState(button, available ? defaultText : soldOutText, '', !available);
    }
  }

  async function addToCart(section, form) {
    var button = form.querySelector('[data-ccc-add-button]');
    var message = form.querySelector('[data-ccc-message]');
    var idField = form.querySelector('[name="id"]');
    var quantityField = form.querySelector('[name="quantity"]');

    if (!button || !idField || button.disabled || button.dataset.busy === 'true') return;

    var variantId = Number(idField.value || 0);
    var quantity = Math.max(1, Number(quantityField ? quantityField.value : 1) || 1);
    if (!variantId) return;

    var defaultText = button.dataset.defaultText || 'Add to Cart';
    var loadingText = button.dataset.loadingText || 'Adding...';
    var addedText = button.dataset.addedText || 'Added';
    var errorText = button.dataset.errorText || 'Unable to add';

    button.dataset.busy = 'true';
    setButtonState(button, loadingText, 'is-loading', true);

    if (message) {
      message.textContent = '';
      message.classList.remove('is-error');
    }

    try {
      var addedData;

      var shouldOpenCart = section.dataset.openCartAfterAdd === 'true';

      if (shouldOpenCart && window.CleenyCart && typeof window.CleenyCart.add === 'function') {
        addedData = await window.CleenyCart.add(variantId, quantity);
      } else {
        var response = await fetch(getRootUrl(section) + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });

        addedData = await response.json().catch(function () { return {}; });
        if (!response.ok) {
          throw new Error(addedData.description || addedData.message || errorText);
        }

        try {
          var cart;
          if (window.CleenyCart && typeof window.CleenyCart.refresh === 'function') {
            cart = await window.CleenyCart.refresh();
          } else {
            var cartResponse = await fetch(getRootUrl(section) + 'cart.js', {
              headers: { Accept: 'application/json' }
            });
            cart = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('cleeny:cart:updated', { detail: { cart: cart } }));
          }
        } catch (refreshError) {
          // Cart refresh is best effort when the custom CLEENY header is not present.
        }

        if (shouldOpenCart) {
          if (window.CleenyCart && typeof window.CleenyCart.open === 'function') {
            await window.CleenyCart.open();
          } else {
            var customCartButton = document.querySelector('[data-cleeny-cart-open]');
            var dawnCartDrawer = document.querySelector('cart-drawer');
            var cartNotification = document.querySelector('cart-notification');

            if (customCartButton) customCartButton.click();
            else if (dawnCartDrawer && typeof dawnCartDrawer.open === 'function') dawnCartDrawer.open();
            else if (cartNotification && typeof cartNotification.open === 'function') cartNotification.open();
          }
        }
      }

      setButtonState(button, addedText, 'is-added', true);
      if (message) message.textContent = 'Added to your cart.';

      var detail = {
        source: 'cleeny-collection-carousel',
        added: addedData,
        variantId: variantId
      };

      ['ajaxProduct:added', 'cart:refresh', 'cart:updated', 'cart:change'].forEach(function (eventName) {
        document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));
      });

      window.setTimeout(function () {
        button.dataset.busy = 'false';
        setButtonState(button, defaultText, '', false);
        if (message) message.textContent = '';
      }, 1600);
    } catch (error) {
      var finalMessage = error && error.message ? error.message : errorText;
      button.dataset.busy = 'false';
      setButtonState(button, errorText, 'is-error', false);

      if (message) {
        message.textContent = finalMessage;
        message.classList.add('is-error');
      }

      window.setTimeout(function () {
        setButtonState(button, defaultText, '', false);
      }, 2200);
    }
  }

  function initSection(section) {
    if (!section || section.dataset.cccReady === 'true') return;
    section.dataset.cccReady = 'true';

    var track = section.querySelector('[data-ccc-track]');
    var previous = section.querySelector('[data-ccc-prev]');
    var next = section.querySelector('[data-ccc-next]');
    var ticking = false;

    if (previous) {
      previous.addEventListener('click', function () {
        scrollTrack(section, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollTrack(section, 1);
      });
    }

    if (track) {
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(function () {
          updateCarousel(section);
          ticking = false;
        });
      }, { passive: true });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollTrack(section, -1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollTrack(section, 1);
        }
      });
    }

    section.querySelectorAll('[data-ccc-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        updateVariantCard(select.closest('[data-ccc-card]'), select);
      });
    });

    section.querySelectorAll('[data-ccc-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(section, form);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        updateCarousel(section);
      }, 100);
    }, { passive: true });

    updateCarousel(section);
    window.setTimeout(function () { updateCarousel(section); }, 160);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) initSection(section);
  });
})();